export const topBarHeight = 64
export const sideNavWidth = 280
export const navbarHeight = 60
export const sidenavCompactWidth = 50
export const containedLayoutWidth = 1200